import { Component } from '@angular/core';

@Component({
  selector: 'yi-loader',
  template: require('./yi_loader.component.html'),
  styles: [require('./yi_loader.component.scss')]
})

export class LoaderComponent {

}
